import TalentList from '../../views/talent/List.vue';

// モデル一覧
window.Vue.component('talent-list', TalentList);
